import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import SlidingSwitch from "../../SlidingSwitch/index";

export default function ServiceCards({
  serviceList,
  activeServices,
  isLoading,
  handleChange,
  isEdit,
}) {
  return (
    <>
      {isLoading ? (
        <div className="grid">
          {Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="col-4 lg:col-4 md:col-12 sm:col-12 xs:col-12"
            >
              <Skeleton className="loading-skeleton" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid">
          {serviceList?.map((x) => {
            return (
              <div
                key={x.id}
                className="col-4 lg:col-4 md:col-12 sm:col-12 xs:col-12"
              >
                <Card
                  className="p-card p-component"
                  style={{
                    border: "1px solid #ddd",
                    boxShadow: "none",
                    padding: 15,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div className="flex justify-content-between align-items-center mb-2">
                    <div
                      className="service__icon__container"
                      style={{
                        backgroundColor: x?.secondary_color,
                      }}
                      dangerouslySetInnerHTML={{ __html: x.icon }}
                    />
                    <SlidingSwitch
                      checked={activeServices?.some(
                        (service) => service?.id === x?.id,
                      )}
                      disabled={!isEdit}
                      onChange={() => handleChange(x)}
                    />
                  </div>
                  <h3 className="service_item_heading mt-2">{x.name}</h3>
                  <p className="service_item_subheading mt-2">
                    {x.description}
                  </p>
                </Card>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
